var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalletCompactLogoBg = function SvgWalletCompactLogoBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#WalletCompactLogoBg_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.49 27.037 16.253 6.892c-1.095-1.665-3.368-2.145-5.056-1.057l-9.54 6.12a3.593 3.593 0 0 0-1.064 5.002l13.23 20.145c1.095 1.665 3.367 2.145 5.055 1.058l9.54-6.12a3.602 3.602 0 0 0 1.072-5.003Z",
    fill: "#00B0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.242 1.95 30.81.045c-2.377-.337-4.582 1.32-4.912 3.675l-3.99 28.448c-.33 2.355 1.342 4.552 3.72 4.89l13.432 1.905c2.377.337 4.582-1.32 4.912-3.675l3.99-28.448c.33-2.355-1.342-4.552-3.72-4.89Z",
    fill: "#F0F1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "WalletCompactLogoBg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v39H0z"
  })))));
};
export default SvgWalletCompactLogoBg;